import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  //justify-content: space-between;
  flex-direction: column;
  flex-wrap: wrap;
  margin: 25px 0;
  height: 600px;
  
  @media (min-width: ${breakpoints.desktop}) {
  flex-direction: column;
  flex-wrap: wrap;
  height: 800px;
  }`;

export const NoDataIcon = styled(FontAwesomeIcon)`

    `;

export const Text = styled.p`
  color: white;
`
